class Model {
  constructor() {
    this.descricao = "";
    this.id = 0;
    this.limit = 10;
    this.offset = 0;
    this.status = "INSERT";
  }
}

const ModelValidation = {};

export { Model, ModelValidation };
